import Pfc from '@finance/pfc';



const pfc = new Pfc({
  service_id: 'spin',
  env: process.env.ENV as string,
  region: 'th',
  language: 'en',
});


export default pfc;

